import { useEffect, useMemo, useState } from 'react'

import { PolygonPlaneMeshProps } from '@editor/interfaces/canvas'
import { useToolUtilSelector } from '@editor/store/selectors'
import { merge } from 'lodash'

const useConfigs = ({
  id,
  label,
  guideLine,
  guideOutline,
  guideLabel,
}: PolygonPlaneMeshProps): {
  isHoverSelected: boolean
  labelConfig: PolygonPlaneMeshProps['label']
  guideLineConfig: PolygonPlaneMeshProps['guideLine']
  guideOutlineConfig: PolygonPlaneMeshProps['guideOutline']
  guideLabelConfig: PolygonPlaneMeshProps['guideLabel']
} => {
  // Store
  const hoveredElementId = useToolUtilSelector((state) => state.hoveredElementId)
  const selectedElementIds = useToolUtilSelector((state) => state.selectedElementIds)

  // States
  const [isHoverSelected, setIsHoverSelected] = useState(false)

  // Label Configs
  const labelConfig = useMemo(
    (): PolygonPlaneMeshProps['label'] =>
      label
        ? merge(
            {},
            {
              color: 'black',
              backgroundColor: 'yellow',
            },
            label,
          )
        : undefined,
    [label],
  )

  // Guide Configs
  // For as long as any of guideLabel, guideLine, or guideOutline is defined, guides will be shown.
  const guideLineConfig = useMemo(
    (): PolygonPlaneMeshProps['guideLine'] => (guideLine ? merge({}, guideLine) : undefined),
    [guideLine],
  )
  const guideOutlineConfig = useMemo(
    (): PolygonPlaneMeshProps['guideOutline'] => (guideOutline ? merge({}, guideOutline) : undefined),
    [guideOutline],
  )
  const guideLabelConfig = useMemo(
    (): PolygonPlaneMeshProps['guideLabel'] =>
      guideLabel
        ? merge(
            {},
            {
              color: '#000',
              backgroundColor: '#fff',
            },
            guideLabel,
          )
        : undefined,
    [guideLabel],
  )

  /**
   * Update hover/selected state
   */
  useEffect(() => {
    setIsHoverSelected(hoveredElementId === id || selectedElementIds.includes(id))
  }, [hoveredElementId, selectedElementIds, id])

  return {
    isHoverSelected,

    labelConfig,
    guideLineConfig,
    guideOutlineConfig,
    guideLabelConfig,
  }
}

export default useConfigs
